export default __webpack_public_path__ + "static/media/Alafinov_Innokenty_Sergeevich.d770648a.webp";